export default __webpack_public_path__ + "static/media/plane.695e2a6f.svg";